export default {"src":"/_next/static/media/Farmers.b505ac53.svg","height":44,"width":82};